/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CreationPageFooter.vue?vue&type=template&id=2a31c9fe&"
import script from "./CreationPageFooter.vue?vue&type=script&lang=js&"
export * from "./CreationPageFooter.vue?vue&type=script&lang=js&"
import style0 from "./CreationPageFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports